import React from "react";
import { NavLink } from "react-router-dom";

import "./home.css";
import ibroFlyer from "../components/img/ibro-flyer.png"

import HeaderImg from "./img/browncounty.jpg";

const Home = () => {

  // const fridaySchedule = [
  //   { time: "3pm - 7pm", event: "Doors open for vendor sales" },
  //   { time: "4pm - 7pm", event: "Pre-registration for Saturday's conference" },
  //   { time: "5pm - 7pm", event: "Townhall" },
  //   { time: "8pm", event: "Venue closed" },
  //   { time: "8pm - 10:45pm", event: "Fireside Chat (at undisclosed location) – Requires separate ticket" }
  // ];

  // const saturdaySchedule = [
  //   { time: "8am - 7pm", event: "Doors open for vendor sales" },
  //   { time: "8am - 5pm", event: "Registration for speaker event" },
  //   { time: "10:30am - 6pm", event: "Door prizes drawn between speakers (must be present to win)" },
  //   { time: "9am - 6pm", event: "Speakers (visit speaker page for more info)" },
  //   { time: "6pm - 7pm", 
  //     event: "Auction (must be present to win). Auction items thus far:", 
  //     details: [
  //       "Bigfoot Family of 3",
  //       "Concrete Bigfoot",
  //       "Signed Speaker Posters (2 x 3)",
  //       "Conference Poster (4 x 8)"
  //     ]
  //   },
  //   { time: "8pm", event: "Venue closed" }
  // ];

  return (
    <div>
      {/* HEADER IMG */}
      <div className="headerImg">
        <img src={HeaderImg} alt="" />
      </div>
      
      <div id="hp">
        <div className="hp-container">
          <div className="hp-content">
            {/* <span className="hp-topper">Indiana's 3rd Annual Bigfoot Conference</span> */}
            <h2 className="hp-title">Indiana Bigfoot Conference</h2>
          </div>

          <div className="hp-text-container">
            <h2>September 24th - September 25th, 2027</h2>
            <h2>The Seasons Lodge, Nashville, Indiana</h2>
            <NavLink className="tickets-btn" to="/tickets">Buy Tickets!</NavLink>
            <h3>Join us for the Indiana Bigfoot Conference, taking place September 24th–25th! Immerse yourself in firsthand experiences, shop from local artists, and connect with fellow enthusiasts.</h3>
          </div>

            {/* <h1 className="schedule-title">Schedule</h1>
            <div className="schedule-container">
              <div className="day-schedule">
                <div className="day-title">
                  <h2>Friday September 26th</h2>
                  <p>(Vendors & Town Hall open to the public)</p>
                </div>
                <div className="events">
                  {fridaySchedule.map((item, index) => (
                    <div key={index} className="event">
                      <span className="time">{item.time}</span>
                      <span className="event-name">{item.event}</span>
                    </div>
                  ))}
                </div>
              </div> */}
              {/* <div className="day-schedule">
        <div className="day-title">
          <h2>Saturday September 27th</h2>
          <p>(Vendors open to the public)</p>
        </div>
        <div className="events">
          {saturdaySchedule.map((item, index) => (
            <div key={index} className="event">
              <span className="time">{item.time}</span>
              <div className="event-content">
                <span className="event-name">{item.event}</span>

              {item.details && (
                <ul className="event-details">
                  {item.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          ))} */}
        {/* </div>
      </div>
    </div> */}


          <div className="flyer-container">
            {/* <picture className="con-flyer">
              <img 
              loading="lazy"
              decoding="async"
              srcSet={conFlyer}
              alt="Indy Bigfoot Con Flyer"
              aria-hidden="true"
              />
            </picture> */}

            <div className="sponsors-container">
  {/* Our Sponsors at the top */}
  {/* <div className="vendor-list">
    <h2>Our Sponsors</h2>
    <ul>
      <li>
        Daily Grind
        <picture className="daily-grind-photo">
          <img 
            loading="lazy"
            decoding="async"
            srcSet={dailyGrind}
            alt="Daily Grind Logo"
            aria-hidden="true"
          />
        </picture>
      </li>
      <li>Members of The Indiana Bigfoot Organization</li>
    </ul>
  </div> */}

  {/* Flex row for the bottom two */}
  <div className="sponsors-row">
    <div className="host-flyer">
      <h2>Special Thanks to IBRO for Hosting Indiana Bigfoot Conference</h2>
      <h2 id="site-link">
      </h2>
      <picture className="ibro-flyer">
        <img 
          loading="lazy"
          decoding="async"
          srcSet={ibroFlyer}
          alt="IBRO Flyer"
          aria-hidden="true"
        />
      </picture>
    </div>

    <div className="vendor-list">
  {/* <h2>Vendor List</h2>
  <ul>
    <li>Anita Akins / Handmade Bigfoot Collectibles</li>
    <li>Jim & Jane Berner / Mudworks / Everything Bigfoot</li>
    <li>Justin Coburn / Author of The Magnetic Portal Field Guide</li>
    <li>Shannon Corum / Handmade & Laser items</li>
    <li>Todd & Brian / Cryptic Creatures / Various Bigfoot Items</li>
    <li>Kristen Fletcher / Cryptid Themed Items</li>
    <li>Amanda Lucas / The Feisty Unicorn / Bigfoot items & Home Decor</li>
    <li>Aaron McAtee / Squatch Holler Indiana / Bigfoot Sounds & Recordings</li>
    <li>Mark Randall / Creative Artist / Bigfoot & Paranormal Items</li>
    <li>Pfeiffer & Riggs / Bigfoot Equipment</li>
    <li>Tammy Siscoe / Bigfoot themed Handmade Items</li>
    <li>Jason Whitaker / Bigfoot Search Gear / Various Artist Designed Items</li>
    <li>Timothy Williams / TW Williams Fine Arts / Can you find Bigfoot in his oil paintings?</li>
    <li>Brandon Wright / Tinfoil Tales Podcast / Podcast & Apparel</li>
    <li>Roviena Wagner / Handmade & Laser Items (3D Printer)</li>
  </ul> */}
</div>

  </div>
</div>

          </div>

          <div className="dev-team-text-container">
            <h3>Website created by Alyssa Wiser</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
